import React from "react";
import moment from "moment";
import UserProfileLink from "components/shared/user-profile-link";

const TherapyDataChangeLogTableRow = (row) => {

  const { Timestamp, ColumnChanged, PreviousValue, NewValue, UpdatedBy, UpdatedById } = row;
  return (
    <tr>
      <td>{moment(Timestamp).format('lll')}</td>
      <td>{ColumnChanged}</td>
      <td>{PreviousValue}</td>
      <td>{NewValue}</td>
      <td>
        <UserProfileLink userId={UpdatedById} linkedUserIsS3Staff>
          {" "}
          {UpdatedBy}
        </UserProfileLink>
      </td>
    </tr>
  );

}
export default TherapyDataChangeLogTableRow;